import { useState } from 'react'
import { Operation } from 'fast-json-patch'
import { useTranslation } from 'react-i18next'

import { useFetch } from '../useFetch'
import { useAuth } from '../../contexts/AuthContext'

import { CONFIG } from '../../config'
import { CourtModel } from '../../types/court/court'
import { ApiError } from '../../types/exception/errorStatus'
import { getErrorMessage } from '../../utils/exception/exceptionUtils'

export function useUpdateCourt() {
  const { t } = useTranslation(['courts', 'exceptions'])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState<string | null>(null)
  const { authInfo } = useAuth()
  const { patcher } = useFetch(authInfo?.accessToken, authInfo?.refreshToken)

  const resetState = () => {
    setLoading(false)
    setError(null)
    setSuccess(null)
  }

  const updateCourt = async (
    courtId: number,
    patch: Operation[]
  ): Promise<CourtModel | undefined> => {
    setLoading(true)
    setError(null)
    setSuccess(null)
    try {
      const data = await patcher<CourtModel>(
        `${CONFIG.BOUNCE_API}/api/v1/management/courts/${courtId}`,
        patch,
        'application/json-patch+json'
      )
      if (!data) {
        return undefined
      }
      setSuccess(t('courts:courts.court.successfully-updated'))
      return data
    } catch (error) {
      console.error(error)
      if (error instanceof ApiError) {
        setError(getErrorMessage(error.data))
      } else {
        setError(t('exceptions:unknown'))
      }
      return undefined
    } finally {
      setLoading(false)
    }
  }

  return {
    updateCourt,
    loading,
    error,
    success,
    resetState,
  }
}
